import React, { useEffect } from 'react';
import { Box, Button, Grid, IconButton, Slider, Typography } from '@mui/material';
import HEADPHONES from '../../assets/images/headphones.svg'
import audioGif from "../../assets/images/audio.gif";
import play from "../../assets/images/play.svg";
import plus from "../../assets/images/plus button.svg";
import minus from "../../assets/images/minus button.svg";
import speaker from "../../assets/images/speaker.svg";


const PhaseFourUI = ({handleNext, handleTinnitusLoudnessTest, isPlaying, tinnitusLoudness, setTinnitusLoudness, increaseTinnitusLoudness, decreaseTinnitusLoudness}) => {

  
  return (
    <>
    <Box sx={{display:'flex', flexDirection:'column', alignItems:'center', height:'20vh'}}>
  <Typography   mt={3} mb={3} className='AxiformaBold' align="center" fontWeight={700} fontSize={'32px'} color={"#5E5E5E"}>
  Adjust the loudness slider until it matches the volume of your tinnitus
  </Typography>
<Box mt={4} mb={4} sx={{display:'flex' , flexDirection:'column', width:'70%', alignItems:'center', justifyContent:'center'}}>
 
        <IconButton
              variant="contained"
              onClick={handleTinnitusLoudnessTest}
          
             
            >
              <img src={isPlaying ? audioGif : play}  alt="Play Button" style={{ height: "10vh" }} />
            </IconButton>
            <Box mt={6} sx={{ minWidth: '62vw', height: '12vh', border: '1px solid #DEDEDE',borderRadius:'8px', display: 'flex' }}>
 
  <Box sx={{display:'flex', justifyContent:'center', alignContent:'center', padding:'10px', width:'6vw'}}>
<img src={speaker} style={{width:'3vw'}}></img>
  </Box>
<Box sx={{ width: '50vw', height: '12vh', border: '1px solid #DEDEDE', background: '#F5F5F5', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', p: 4 }}>
              <IconButton onClick={decreaseTinnitusLoudness}>
                <img src={minus} alt="Minus" />
                </IconButton>
              </Box>
            
              <Box sx={{ width: '50vw', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Slider
                  value={tinnitusLoudness}
                  onChange={(e, value) => setTinnitusLoudness(value)}
                  min={10}
                  max={100}
                  step={10}
                  sx={{
                    width: "100%",
                    mx: 2,
                    color: "#d34646",
                    height: 10,
                    "& .MuiSlider-thumb": {
                      height: 24,
                      width: 24,
                      bgcolor: "#ffffff",
                      border: "2px solid #d34646",
                      "&:before": {
                        position: "absolute",
                        border: '1px solid #D34646',
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: "12px",
                        fontWeight: "bold",
                        color: "#000",
                      },
                      "&:hover, &.Mui-focusVisible": {
                        boxShadow: "0px 0px 0px 5px rgba(211, 70, 70, 0.16)",
                      },
                    },
                    "& .MuiSlider-rail": {
                      color: "#D9D9D9",
                      opacity: 1,
                      height: 8,
                    },
                    "& .MuiSlider-track": {
                      height: 8,
                      border: "none",
                    },
                    "& .MuiSlider-mark": {
                      height: 8,
                      width: 2,
                      borderRadius: 1,
                      position: "absolute",
                      top: -2,
                    },
                  }}
                />
              </Box>
            
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 4  }}>
                <IconButton onClick={increaseTinnitusLoudness}> <img src={plus} alt="Plus" /></IconButton>
               
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding:'10px' }}>
  <Typography variant="h2" sx={{ color: "#424242", marginRight: '4px' }}>
    {tinnitusLoudness}
  </Typography>
  <Typography  sx={{ color: "#B3B3B3", fontSize:'13px' }}>
    DB
  </Typography>
</Box>
</Box>
           
    </Box>
   
    <Button  sx={{width:'30vw', height:'12vh',background:'#424242', radius:'8px', alignItems:'center', color:'white', marginTop:'65px'}} onClick={handleNext}>
      <Typography sx={{fontSize:'24px'}}>Confirm Loudness</Typography>  
    </Button>

  </Box>
    </>
  
)}

export default PhaseFourUI;
